import exceljs from "exceljs";
import { saveAs } from "file-saver";
import type { TableColumnProperties } from "exceljs";

import { mimeTypeMap, MyDate, getDateEndFromWeekNum, numberReducer } from "src/components/common/functions";
import type { LaborCostProject, LaborCostWeekMap } from "./actions_loaders";

export default function Export({
    filteredProjectIds,
    visibleWeeks,
    projectsMap,
    rawData,
}: {
    filteredProjectIds: string[];
    visibleWeeks: string[];
    projectsMap: Record<string, LaborCostProject>;
    rawData: LaborCostWeekMap;
}) {
    const exportFunc = async () => {
        if (!filteredProjectIds.length) {
            window.alert("No data to export.");
            return;
        }

        const workbook = new exceljs.Workbook();
        workbook.created = new Date();
        workbook.calcProperties.fullCalcOnLoad = true;

        const worksheet = workbook.addWorksheet("Labor Cost", {
            views: [{ showGridLines: false }],
        });
        worksheet.state = "visible";
        worksheet.properties.defaultColWidth = 22.57;

        const rows = filteredProjectIds.map(projectId => {
            const amounts = visibleWeeks.map(week => rawData[week]?.[projectId] ?? 0);
            return [
                projectsMap[projectId]?.projectName ?? projectId,
                ...amounts,
                amounts.reduce(numberReducer, 0),
            ];
        });
        const columns: TableColumnProperties[] = [
            { name: "Project Name", filterButton: true },
            ...visibleWeeks.map(week => ({
                name: getDateEndFromWeekNum(week) ?? week,
                filterButton: true,
                totalsRowFunction: "sum" as const,
            })),
            { name: "Total Labor Cost", filterButton: true, totalsRowFunction: "sum" as const },
        ];

        worksheet.addTable({
            name: "LaborCostTable",
            ref: "A1",
            totalsRow: true,
            style: {
                showRowStripes: true,
            },
            columns,
            rows,
        });

        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(
            new Blob([buffer], { type: mimeTypeMap.xlsx }),
            `Labor Cost export ${(new MyDate()).s()}.xlsx`
        );
    };

    if (!filteredProjectIds.length) return null;
    return (
        <button type="button" className="btn btn-outline-primary" onClick={exportFunc}>
            Export
        </button>
    );
}
